import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { ROUTE_LOGIN } from "@/constants/routes";
import { useAuth } from "./useAuth";
import { useMe } from "@/hooks/useMe";

export function RequireAuth({ children }: PropsWithChildren): JSX.Element {
  const { firebaseUser, loading: authLoading } = useAuth();
  const { me, loading: meLoading, error } = useMe();

  if (authLoading) return <div aria-busy="true">Loading…</div>;
  if (!firebaseUser) return <Navigate to={ROUTE_LOGIN} replace />;
  if (error) {
    return (
      <div role="alert">
        <p>Something went wrong loading your profile.</p>
        <p>Please reload the page.</p>
      </div>
    );
  }
  if (meLoading || !me) return <div aria-busy="true">Loading…</div>;
  return <>{children}</>;
}
